import LoadingBar from "react-top-loading-bar";
import Loading from "react-fullscreen-loading";
import Select from "react-select";
import { LangLabel } from "data/LangLabel";
import validator from "validator";
import moment from "moment";

export const LoadingTopBar = (color, progress) => {
  return <LoadingBar color={color || "red"} progress={progress} />;
};

export const LoadingContent = () => {
  return (
    <Loading
      loading
      background="rgba(0, 0, 0, 0.35)"
      loaderColor="rgba(252, 219, 86, 1)"
    />
  );
};

export const openTab = (url) => {
  if (url === undefined) {
    return false;
  }
  window.open(url);
  return true;
};

export const RenderField = ({
  input,
  label,
  type,
  readOnly,
  placeholder,
  id,
  tabIndex,
  autoFocus,
  ref,
  customeCss,
  minLength,
  defaultValue,
  maxLength,
  uppercase,
  textColor = "text-black",
  formGroup,
  iconFormGroup,
  meta: { touched, error, warning },
}) => (
  <div className="form-group">
    {label && (
      <label htmlFor="" className={textColor}>
        {label || <> &nbsp; </>}
      </label>
    )}
    <div className="input-group">
      <input
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            event.preventDefault(); //<===== This stops the form from being submitted
          } else {
          }
        }}
        {...input}
        tabIndex={tabIndex}
        ref={ref}
        autoComplete="off"
        type={type}
        id={id}
        style={{ textTransform: uppercase ? "uppercase" : "none" }}
        className={`form-control ${touched && error && "is-invalid "} ${customeCss || ""} `}
        readOnly={readOnly}
        minLength={minLength}
        maxLength={maxLength}
        placeholder={placeholder}
      />
      {formGroup && (
        <div className="input-group-append">
          <div className="input-group-text">
            <span className={iconFormGroup}></span>
          </div>
        </div>
      )}
      {touched &&
        ((error && <span className="error invalid-feedback">{error}.</span>) ||
          (warning && <p>{warning}</p>))}
    </div>
  </div>
);

export const RenderSelect = ({
  input,
  label,
  readOnly,
  placeholder,
  options,
  onChange,
  id,
  disabled,
  tabIndex,
  meta: { touched, error, warning },
  value,
  textColor = "text-black",
}) => (
  <div className="form-group">
    <label htmlFor="" className={textColor}>
      {label}
    </label>
    <Select
      {...input}
      id={id}
      readOnly={readOnly}
      onChange={(value) => input.onChange(value)}
      onBlur={() => input.onBlur(input.value)}
      tabIndex={tabIndex}
      placeholder={placeholder}
      isDisabled={disabled}
      options={options}
      styles={{
        control: (base, state) => ({
          ...base,
          border: touched && error && "1px solid red",
          boxShadow: "none",
          "&:hover": {
            border: touched && error && "1px solid red",
            boxShadow: "none",
          },
        }),
        // Fixes the overlapping problem of the component
        menu: (provided) => ({ ...provided, zIndex: 9999 }),
      }}
    />
    {touched &&
      ((error && <span className="error invalid-feedback">{error}.</span>) ||
        (warning && <p>{warning}</p>))}
  </div>
);

export const ErrorMessage = (errors) => {
  var msg = "";
  for (var key of Object.keys(errors)) {
    msg = msg + errors[key].message + "\n";
  }
  return msg;
};

export const RuleRequired = { required: LangLabel.MSG_REQUIRED };
export const RuleMinLen = (min) => {
  return {
    required: LangLabel.MSG_REQUIRED,
    minLength: {
      value: min,
      message: `${LangLabel.MSG_PASS_MIN_LENGTH_1} ${min} ${LangLabel.MSG_PASS_MIN_LENGTH_2}`,
    },
  };
};

export const validateCheckboxRequired = (value) =>
  value === true || LangLabel.MSG_REQUIRED;
export const RuleConfirmPass = (confname) => {
  const fnc = (value, formValue) =>
    formValue[confname] === value ||
    LangLabel.MSG_PASSWORD_CHANGED_DOESNOT_MATCH;
  return fnc;
};

export const RuleConfirmPassword = (confname) => {
  const fnc = (value, formValue) =>
    formValue[confname] === value || LangLabel.MSG_PASSWORD_DOESNOT_MATCH;
  return fnc;
};

export const RuleRequiredCheckbox = () => {
  const fnc = (value, formValue) => value === false || LangLabel.MSG_REQUIRED;
  return fnc;
};

export const RuleRequiredDate = (value, formValue) => {
  if (value == null || value === "") {
    return LangLabel.MSG_REQUIRED;
  }

  if (value instanceof Date) {
    return moment(value).isValid() || LangLabel.MSG_REQUIRED;
  }

  const raw = (value + "").trim();
  if (raw.length === 0) {
    return LangLabel.MSG_REQUIRED;
  }

  if (validator.isDate(raw)) {
    return true;
  }

  if (moment(raw).isValid()) {
    const normalized = moment(raw).format("YYYY-MM-DD");
    return validator.isDate(normalized) || LangLabel.MSG_REQUIRED;
  }

  return LangLabel.MSG_REQUIRED;
};

export const RuleRequiredEmail = (value, formValue) => {
  const ok = validator.isEmail(value + "");
  return ok || LangLabel.MSG_REQUIRED_EMAIL;
};

export const RuleOptionalEmail = (value, formValue) => {
  const email = value == null ? "" : value + "";
  let ok = true;
  if (email.length > 0) {
    ok = validator.isEmail(email);
  }
  return ok || LangLabel.MSG_REQUIRED_EMAIL;
};

export const RuleRequiredPhone = (value, formValue) => {
  const ok = validator.isMobilePhone(value + "");
  return ok || LangLabel.MSG_REQUIRED_PHONE;
};

export const RuleRequiredNumeric = (value, formValue) => {
  const ok = validator.isNumeric(value + "");
  return ok || LangLabel.MSG_NOT_VasyALID;
};

export const RuleRequiredDateTime = (value, formValue) => {
  let myval = value;
  if (moment(value).isValid()) {
    myval = moment(value).utc(false).format("YYYY-MM-DD HH:mm");
  }
  const arrVal = myval.split(" ");
  let ok = false;
  if (arrVal.length === 2) {
    ok = validator.isDate(arrVal[0] + "");
    ok = ok && validator.isTime(arrVal[1] + "");
  } else {
    ok = false;
  }

  return ok || LangLabel.MSG_REQUIRED;
};

export const ArrFrom = (first, end, inc = 1) => {
  let ret = [];
  for (let i = Number(first); i <= Number(end); i = i + Number(inc)) {
    ret = [...ret, i];
  }
  return ret;
};

export const getMax = (data, attribute) => {
  const max = data.reduce((p, c) => (p[attribute] > c[attribute] ? p : c));
  return max;
};

export const getDateViewFromMysql = (strmysqldate) => {
  if (!strmysqldate) return "";
  const matchedDate = typeof strmysqldate === "string" ? strmysqldate.match(/^(\d{4})-(\d{2})-(\d{2})/) : null;
  if (matchedDate) {
    return new Date(
      Number(matchedDate[1]),
      Number(matchedDate[2]) - 1,
      Number(matchedDate[3]),
    );
  }
  let date = strmysqldate.replace(/[-]/g, "/");
  date = date.replace(/[T]/g, " ");
  date = date.replace(/[Z]/g, "");
  date = Date.parse(date);
  let jsDate = new Date(date);
  return jsDate;
};

export const getStrDateForMysql = (date) => {
  let resdate = "";
  const matchedDate = typeof date === "string" ? date.match(/^(\d{4})-(\d{2})-(\d{2})/) : null;
  if (matchedDate) {
    return `${matchedDate[1]}-${matchedDate[2]}-${matchedDate[3]}`;
  }
  if (moment(date).isValid()) {
    resdate = moment(date).format("YYYY-MM-DD");
  }
  return resdate;
};

export const money = (x) => {
  if (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return "0";
  }
};

export const getStrDateLong = (strdate) => {
  let date = getDateViewFromMysql(strdate);
  let resdate = "";
  if (moment(date).isValid()) {
    moment.locale("id");
    resdate = moment(date).format("DD MMMM YYYY");
  }
  return resdate;
};

export const getStrDateShort = (strdate) => {
  let date = getDateViewFromMysql(strdate);
  let resdate = "";
  if (moment(date).isValid()) {
    moment.locale("id");
    resdate = moment(date).format("DD/MM/YYYY");
  }
  return resdate;
};

export const getStrDateTimeShort = (strdate) => {
  //let date = getDateViewFromMysql(strdate)
  let resdate = "";
  if (moment(strdate).isValid()) {
    //moment.locale("id")
    resdate = moment(strdate).utc(false).format("DD/MM/YYYY HH:mm");
  }
  return resdate;
};

export const getStrTimeInput = (strtime) => {
  if (strtime === null || strtime === undefined) return "";
  if (strtime instanceof Date && moment(strtime).isValid()) {
    return moment(strtime).format("HH:mm");
  }

  const raw = String(strtime).trim();
  if (!raw) return "";

  const matched = raw.match(/(\d{2})[:.](\d{2})/);
  if (matched) {
    return `${matched[1]}:${matched[2]}`;
  }

  return "";
};

export const getStrTimeShort = (strtime) => {
  const normalized = getStrTimeInput(strtime);
  if (!normalized) return "";
  return normalized.replace(":", ".");
};

export const getStrTimeRange = (startTime, endTime) => {
  const start = getStrTimeShort(startTime);
  const end = getStrTimeShort(endTime);
  if (start && end) return `${start} - ${end}`;
  return start || end || "";
};

export const getStrDateFromPostgres = (strdate) => {
  //let date = getDateViewFromMysql(strdate)
  let resdate = "";
  if (moment(strdate).isValid()) {
    //moment.locale("id")
    resdate = moment(strdate).utc(false).format("DD/MM/YYYY");
  }
  return resdate;
};

export const getStrDateLongFromPostgres = (strdate) => {
  //let date = getDateViewFromMysql(strdate)
  let resdate = "";
  if (moment(strdate).isValid()) {
    //moment.locale("id")
    resdate = moment(strdate).utc(false).format("DD MMMM YYYY");
  }
  return resdate;
};

export const postgresDateToIndonesia = (strdate) => {
  let resdate = "";
  const matchedDate = typeof strdate === "string" ? strdate.match(/^(\d{4})-(\d{2})-(\d{2})/) : null;
  if (matchedDate) {
    const monthIndex = parseInt(matchedDate[2], 10) - 1;
    const bulan = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ][monthIndex];
    return `${matchedDate[3]} ${bulan || ""} ${matchedDate[1]}`.trim();
  }
  if (moment(strdate).isValid()) {
    const m = moment(strdate);
    const day = m.format("DD");
    const monthIndex = parseInt(m.format("M"), 10) - 1;
    const year = m.format("YYYY");
    const bulan = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ][monthIndex];
    resdate = `${day} ${bulan || ""} ${year}`.trim();
  }
  return resdate;
};

export const getStrDateNow = (strdate) => {
  let date = new Date();
  let resdate = "";
  if (moment(date).isValid()) {
    moment.locale("id");
    resdate = moment(date).utc(true).format("DD MMMM YYYY");
  }
  return resdate;
};

export const getAge = (birth, nowdate) => {
  let today = nowdate;
  let other_date = getDateViewFromMysql(birth).getTime();
  let difference = Math.abs(today - other_date);

  let days = Math.floor(difference / (1000 * 3600 * 24));
  let years = Math.floor(days / 365);
  days -= years * 365;
  let months = Math.floor(days / 31);
  days -= months * 31;

  return [years, months, days];
};

export const getAgeDay = (birth, nowdate) => {
  if (!birth) {
    return 0;
  }
  let today = nowdate;
  let other_date = getDateViewFromMysql(birth).getTime();
  let difference = Math.abs(today - other_date);

  let days = Math.floor(difference / (1000 * 3600 * 24));

  return days;
};

export const getByDotted = (obj, path) => {
  const index = path.indexOf(".");
  if (index === -1) {
    return obj?.[path];
  }
  return getByDotted(obj?.[path.slice(0, index)], path.slice(index + 1));
};

export const makeRule = (ruleFunc) => {
  return { validate: (value, formValues) => ruleFunc(value, formValues) };
};

export const validateRequired = RuleRequired;
export const validateOptionalEmail = {
  validate: (value, formValues) => RuleOptionalEmail(value, formValues),
};
export const validateRequiredDate = {
  validate: (value, formValues) => RuleRequiredDate(value, formValues),
};
export const validateRequiredDateTime = {
  validate: (value, formValues) => RuleRequiredDateTime(value, formValues),
};
export const validateRequiredPhone = {
  validate: (value, formValues) => RuleRequiredPhone(value, formValues),
};
export const validateRequiredEmail = {
  validate: (value, formValues) => RuleRequiredEmail(value, formValues),
};
export const validateRequiredNumeric = {
  validate: (value, formValues) => RuleRequiredNumeric(value, formValues),
};

export const strToSHA256 = async (input) => {
  const text = (input ?? "").toString();
  const data = new TextEncoder().encode(text);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};
